module.exports = __webpack_public_path__ + "static/img/1.0179b64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/1.jpg
// module id = YTMB
// module chunks = 15